import { type Scale } from "~/types/hardware";

export function extractScaleIdentifier(scale: Scale) {
  if (typeof scale === "object" && "model" in scale && "scale" in scale) {
    return `${scale.model} - ${scale.scale.deviceId}`;
  }

  if (typeof scale === "object" && "deviceId" in scale) {
    return scale.deviceId;
  }

  return "scale";
}
